import React from 'react';

const Footer = () => {
    return (
        <footer className="py-12 px-6 bg-white border-t border-border">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-muted text-sm">
            © 2026 Natalia Siwek
          </p>
        </div>
      </footer>
    )
}

export default Footer;